import type { SVGProps } from 'react';

export const Gavel = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.8 19.25h10c.217 0 .392.075.525.225.15.133.225.308.225.525 0 .217-.075.4-.225.55a.71.71 0 0 1-.525.2h-10a.766.766 0 0 1-.525-.2.748.748 0 0 1-.225-.55c0-.217.075-.392.225-.525a.72.72 0 0 1 .525-.225Zm3.775-4.95-2.75-2.75a1.827 1.827 0 0 1-.55-1.275c0-.5.175-.925.525-1.275l.5-.525 5.375 5.325-.525.5c-.35.35-.783.525-1.3.525-.5 0-.925-.175-1.275-.525ZM15.8 9.675 10.475 4.3 11 3.8c.35-.35.775-.517 1.275-.5.5 0 .925.175 1.275.525l2.75 2.75c.35.35.525.783.525 1.3 0 .5-.175.925-.525 1.275l-.5.525Zm4.275 9.45L7.9 6.95 8.95 5.9l12.175 12.175a.71.71 0 0 1 .2.525c.017.2-.05.375-.2.525a.72.72 0 0 1-.525.225.72.72 0 0 1-.525-.225Z" />
    </svg>
  );
};
